import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FINANCING INFORMATION", -1)
const _hoisted_3 = {
  key: 0,
  class: "tw-px-4"
}
const _hoisted_4 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_5 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM", -1)
const _hoisted_7 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_8 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS", -1)
const _hoisted_10 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_11 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE", -1)
const _hoisted_13 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "INCOME TYPE:")
], -1)
const _hoisted_15 = { class: "tw-flex tw-justify-center tw-gap-[50px]" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["data-bs-target"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "col" }
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "tw-mt-[40px] tw-mb-5" }
const _hoisted_24 = { class: "tw-flex tw-justify-center tw-gap-[50px]" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["data-bs-target"]
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "col" }
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-[35px] tw-mb-[35px] tw-gap-[50px]" }
const _hoisted_33 = { class: "tw-items-center tw-gap-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " TOTAL MONTHLY INCOME $: ", -1)
const _hoisted_35 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3 d-flex align-items-center justify-contetn-center" }

import { toRefs, watch } from 'vue';
import { currencyFormat } from '@/composables/filters';
import IncomeHourly from './IncomeHourly.vue';
import IncomeWeekly from './IncomeWeekly.vue';
import IncomeBiweekly from './IncomeBiweekly.vue';
import IncomeMonthly from './IncomeMonthly.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DTIFinancingInformation',
  props: {
  customersData: {
    type: Array,
    default: []
  },
  selectedMLO: {
    type: Object,
    default: null
  }
},
  setup(__props) {

const props = __props;


const { customersData, selectedMLO }: any = toRefs(props)

// Watch for changes in any of the income arrays
watch(customersData, (newCustomers) => {
    newCustomers.forEach((customer, customerIndex) => {
        // Sum up all monthly incomes
        const total = (
            // Sum hourly incomes
            customer.hourlyIncome.reduce((sum, income) => sum + (income.monthlyIncome || 0), 0) +
            // Sum weekly incomes
            customer.weeklyIncome.reduce((sum, income) => sum + (income.monthlyIncome || 0), 0) +
            // Sum biweekly incomes
            customer.biweekyIncome.reduce((sum, income) => sum + (income.monthlyIncome || 0), 0) +
            // Sum monthly incomes
            customer.monthlyIncome.reduce((sum, income) => sum + (income.monthlyIncome || 0), 0)
        );

        // Update totalMonthlyIncome
        customersData.value[customerIndex].totalMonthlyIncome = total;
    });
}, { 
    deep: true, // Watch nested objects
    immediate: true // Calculate immediately when component mounts
});

const calculateTotalMonthlyIncome = () => {
  return false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customersData), (customer, w) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (w == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(selectedMLO) !== null ? _unref(selectedMLO).filters.program.toUpperCase() : ''), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(selectedMLO) !== null ? _unref(selectedMLO).filters.year : ''), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(selectedMLO) !== null ? _unref(selectedMLO).interestRate : '') + " % ", 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_14,
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("a", {
                  class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                  "data-bs-toggle": "collapse",
                  href: '#multiCollapseExample1' + w,
                  role: "button",
                  "aria-expanded": "false",
                  "aria-controls": "multiCollapseExample1"
                }, "HOURS", 8, _hoisted_16),
                _createElementVNode("button", {
                  class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": '#multiCollapseExample2' + w,
                  "aria-expanded": "false",
                  "aria-controls": "multiCollapseExample2"
                }, "WEEK", 8, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "collapse multi-collapse",
                    id: 'multiCollapseExample1' + w
                  }, [
                    _createVNode(IncomeHourly, {
                      hourlyIncome: customer.hourlyIncome
                    }, null, 8, ["hourlyIncome"])
                  ], 8, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: "collapse multi-collapse",
                    id: 'multiCollapseExample2' + w
                  }, [
                    _createVNode(IncomeWeekly, {
                      weeklyIncome: customer.weeklyIncome
                    }, null, 8, ["weeklyIncome"])
                  ], 8, _hoisted_22)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, [
                _createElementVNode("a", {
                  class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                  "data-bs-toggle": "collapse",
                  href: '#multiCollapseExample3' + w,
                  role: "button",
                  "aria-expanded": "false",
                  "aria-controls": "multiCollapseExample3"
                }, "BYWEEKLY", 8, _hoisted_25),
                _createElementVNode("button", {
                  class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": '#multiCollapseExample4' + w,
                  "aria-expanded": "false",
                  "aria-controls": "multiCollapseExample4"
                }, "MONTHS", 8, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", {
                    class: "collapse multi-collapse",
                    id: 'multiCollapseExample3' + w
                  }, [
                    _createVNode(IncomeBiweekly, {
                      biweekyIncome: customer.biweekyIncome
                    }, null, 8, ["biweekyIncome"])
                  ], 8, _hoisted_29)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", {
                    class: "collapse multi-collapse",
                    id: 'multiCollapseExample4' + w
                  }, [
                    _createVNode(IncomeMonthly, {
                      monthlyIncome: customer.monthlyIncome
                    }, null, 8, ["monthlyIncome"])
                  ], 8, _hoisted_31)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(currencyFormat)(customer.totalMonthlyIncome)), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
    }), 256))
  ]))
}
}

})